import { render } from "./DefaultPaymentMethodBrand.vue?vue&type=template&id=2a4e2f48"
import script from "./DefaultPaymentMethodBrand.vue?vue&type=script&lang=js"
export * from "./DefaultPaymentMethodBrand.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QItem,QCardSection,QItemSection,QIcon,QItemLabel});
